import React, { memo } from "react";

const InputBlockv1 = memo(
  ({ title, value, setValue, placeholder, error, type, cls }) => {
    const changeOn = (e) => {
      setValue(e.target.value.replace(/[&<>"'`]/g, "\\"));
    };
    return (
      <div className="login_form_container-input">
        <p className="login_form-name">{title}</p>
        <input
          id="inpt_name_id"
          value={value}
          onChange={changeOn}
          className={`login_form-inpt ${cls}`}
          type={type}
          placeholder={placeholder}
        />
        <p className="login_inpt_message_error">{error}</p>
      </div>
    );
  }
);

export default InputBlockv1;
